export { steps } from '~/store/types/updateApplication';

export const BANK_CONNECTION_RESULT_QUERY_STRING_KEY = 'bank_connection_result';
